export default "__VITE_ASSET__OsVVxG0M__"